import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { EntityViewsEffects } from './store/effects/entitiy-views.effects';

@NgModule({
    imports: [
        EffectsModule.forFeature([
            EntityViewsEffects
        ])
    ],
})
export class EntityViewsModule { }